import LoginRoot from '@/views/login/LoginRoot';
import LoginPhone from '@/views/login/LoginPhone';
import LoginEnterOtp from '@/views/login/LoginEnterOtp';
import LoginMemberDoesNotExist from '@/views/login/LoginMemberDoesNotExist';

export default {
  path: '/login',
  name: 'Login',
  component: LoginRoot,
  children: [
    {
      path: 'phone',
      name: 'LoginPhone',
      component: LoginPhone,
    },
    {
      path: 'enter-otp',
      name: 'LoginEnterOtp',
      component: LoginEnterOtp,
    },
    {
      path: '/login/not-a-member',
      name: 'LoginNotAMember',
      component: LoginMemberDoesNotExist,
    },
  ],
};
